module.exports = __webpack_public_path__ + "static/Artboard-8-3d7565f8410a6620f9e3c6d002d59b02.png";